"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizedComponent = void 0;
var tslib_1 = require("tslib");
var casl_1 = require("@readcloud/casl");
var react_1 = tslib_1.__importStar(require("react"));
var hooks_1 = require("../../hooks");
var AuthorizedComponent = function (_a) {
    var children = _a.children, permissions = _a.permissions, redirectTo = _a.redirectTo;
    var ability = (0, hooks_1.usePermissions)();
    var authorized = (0, react_1.useMemo)(function () { return (0, casl_1.isAuthorized)(ability, permissions); }, [
        ability,
        permissions,
    ]);
    return react_1.default.createElement(react_1.default.Fragment, null, authorized ? children : redirectTo);
};
exports.AuthorizedComponent = AuthorizedComponent;
//# sourceMappingURL=index.js.map